import {Component, OnInit} from '@angular/core';

import {ConsultingService, LoaderService, ReportService, SalesService} from '@app/shared/services';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {ModalDismissReasons, NgbHighlight, NgbModal, NgbModalRef, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import * as EmailValidator from 'email-validator';
import {ToastrService} from 'ngx-toastr';
import {UtilsInjectable} from '@app/shared';
import {environment} from '@env/environment';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {NgxPrintDirective} from 'ngx-print';
import {Nl2BrPipe} from '@app/shared/pipe';
import {QRCodeComponent} from 'angularx-qrcode';
import numberToWords from 'number-to-words';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-sale-list',
  templateUrl: './sale-list.component.html',
  imports: [
    CommonModule,
    NgOptimizedImage,
    PageHeaderComponent,
    FormsModule,
    RouterLink,
    NgxPrintDirective,
    NgbHighlight,
    NgbTypeahead,
    Nl2BrPipe,
    QRCodeComponent,
    PaginationComponent,
  ],
  styleUrls: ['./sale-list.component.scss']
})
export class SaleListComponent implements OnInit {


  public user_rights: any;
  public user_data: any = {};
  public now = new Date();

  public sale_details: any = [""];
  public sale_data: any = [];
  start = 0;
  limit = 10;
  p = 50;
  public checked = true;
  public collection: any = '';
  page = 1;

  status: any;
  index: any;
  router: any;
  saled: any;
  closeResult = "";
  public item_list: any = [];
  price_total = 0;

  gross = 0;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  numberToWords: any;
  count: any;
  split = 1;
  public print_list_array: any = [];
  vat_list: any;
  total_vat: any;
  total_flood: any;
  to_mail_address = "";

  public sale: any =
    {
      search_sale: '',
      sale_id: 0,
      patient_name: '',
      payment_type: 1,
      bill_type: 1,
      patient_no: '',
      customer: '',
      doctor: '',
      sale_date: new Date(),
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      state: '',
      state_id: 0,
      order_no: '',
      vat_no: '',
      slab: 1,
      cardno: '',
      chequeno: '',
      remark: "",
      customer_address: "",
      license_no: "",
      shipping_address: "",
      medicine_id_arr: [""],
      base_price: [""],
      slab_per: [""],
      ava_quantity_arr: [""],
      quantity_arr: ["1"],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      medicine_data: [],
      price_arr: [""],
      flood_arr: [""],
      MRP: [""],
      dis_arr: [""],
      user_id: '',
      total_arr: [""],
      unitprice_arr: [""],
      product_arr: [""],
      vat_arr: [""],
      vatamt_arr: [""],
      purchase_details_id_arr: [""],
      warehouse_details_id_arr: [""],
      warehouse_details_id: [""],
      warehouse_arr: [""],
      mark_free_of_cost: [false],
      upload_file: [],
      removeUpload: [],
      warehouses_data: [],
    }

  public sale_credit: any =
    {
      search_sale: '',
      payment_credit: 0,
      credit_date: new Date(),
      payment_received: 0,
      sale_id: '',
      user_id: "",
    }
  searching = false;
  searchFailed = false;
  total_amount = 0;
  net_total = 0;
  warehouses_data: any = [];
  save_rate = 0;
  file_list: any;
  fileName: any[] = [];
  filelist: any;
  payment_total: any;
  cancel_reason: any = '';
  private modalRef?: NgbModalRef;

  constructor(private loaderService: LoaderService,
              private modalService: NgbModal,
              public reportService: ReportService,
              public consultingService: ConsultingService,
              public salesService: SalesService,
              private toastr: ToastrService,
              protected utils: UtilsInjectable) {
  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.getSaleList();
  }

  public selectpaymentcredit(val: any) {
    this.sale_credit.payment_credit = val;
  }

  public savepaymentCredit(content: any) {
    this.sale_credit.user_id = this.user_data.user_id;
    if (this.sale_credit.payment_credit == 1 && this.payment_total > 0 && this.sale_credit.payment_received == 0 || this.sale_credit.payment_received == null) {
      this.toastr.error("Please enter received amount!!")
      this.opens(content);
    } else {
      if (this.sale_credit.payment_credit == 0) {
        this.sale_credit.credit_date = '';
        this.sale_credit.payment_received = '';
      }
      this.loaderService.display(true);
      window.scrollTo(0, 0);
      this.loaderService.display(true);
      this.consultingService.savepaymentCredit(this.sale_credit).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.payment_total = 0;
          this.toastr.success(result["msg"]);
          this.getSaleList(this.page - 1)
          this.loaderService.display(false);
        } else {
          this.loaderService.display(false);
        }
      });
    }
  }

  public saveSale(): any {
    let rel = 1;
    let stock_arr: any[] = [];
    this.sale.medicine_id_arr.forEach((_item: any, index: any): any => {
      let mrp = 0;
      let vat;
      stock_arr.push(this.sale.warehouse_details_id_arr[index]);
      if (this.sale.mark_free_of_cost[index] == false && this.sale.unitprice_arr[index] == 0) {
        this.toastr.error('Please mark the FOC or enter the retail price')
        rel = 0;
        return false;
      }
      if (this.sale.quantity_arr[index] == "" || this.sale.quantity_arr[index] == 0) {
        this.toastr.error('Enter quantity');
        rel = 0;
        return false;
      }
      if (parseInt(this.sale.ava_quantity_arr[index]) < parseInt(this.sale.quantity_arr[index])) {
        this.toastr.error('Invalid quantity');
        rel = 0;
        return false;
      }

      if (this.sale.state != '') {
        vat = parseFloat(this.sale.MRP[index]) * (parseFloat(this.sale.vat_arr[index]) / 100);
        mrp = parseFloat(this.sale.MRP[index]) + vat;

      }
      if (mrp < parseFloat(this.sale.unitprice_arr[index])) {
        this.toastr.error('Retail price should be less than or equal to MRP price');
        rel = 0;
        return false;
      }
      if (parseInt(this.sale.quantity_arr[index]) == 0 || this.sale.quantity_arr[index] == '') {
        this.toastr.error('Invalid Quanttiy');
        rel = 0;
        return false;
      }
    });
    if (rel == 0) {
      return false
    }
    const data = this.checkSameWarehouse(stock_arr);
    if (data > -1) {
      this.toastr.error("Duplicate warehouse is found on " + this.sale.medicine_data[data].TRADE_NAME)
      stock_arr = []
      return false
    }
    this.sale.user_id = this.user_data.user_id
    this.sale.date = this.utils.date(this.sale.date)
    this.sale.sale_id = 0;
    this.loaderService.display(true);
    this.reportService.saveSale(this.sale).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success(result.msg);
        this.modalRef?.close();
        this.sale.sale_id = result.data_id;
        this.clear_sale();
        this.getSaleList(this.page - 1);
        this.router.navigate(['sale/sale-list']);

      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public checkSameWarehouse(stock_arr: any) {
    for (let i = 0; i < stock_arr.length; i++) {
      for (let j = 0; j < stock_arr.length; j++) {
        if (i != j) {
          if (stock_arr[i] == stock_arr[j]) {
            return i;
          }
        }
      }
    }
    return -1;
  }

  public payment_pop(sale_id: any, total_amount: any) {
    this.sale_credit.sale_id = sale_id;
    this.payment_total = total_amount;
  }

  public sendToMail(sendmail: any): any {
    if (this.to_mail_address == '') {
      this.toastr.error('Please enter email address !');
      this.opens(sendmail);
      return false;
    }
    if (this.to_mail_address != '') {
      if (!EmailValidator.validate(this.to_mail_address)) {
        this.toastr.error('Please enter proper email !');
        return false;
      }
    }
    const postData = {
      customer_id: this.saled.PATIENT_NAME,
      customer_name: this.saled.CUSTOMER_NAME,
      to_mail: this.to_mail_address,
      sale_id: this.saled.SALE_ID,
      gross_number: this.gross,
      net_bill_amount: this.price_total,
      numberToWords: this.numberToWords,
      total_vat: this.total_vat,
      total_flood: this.total_flood,
      save_rate: this.save_rate
    }
    this.sale.user_id = this.user_data.user_id
    this.loaderService.display(true);
    this.reportService.sendToMail(postData).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success(result.msg);
        this.sale.sale_id = result.data_id;
        this.router.navigate(['sale/sale-list']);

      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public finalize(sale_id: any) {
    if (confirm("Are you sure to finalize this sale ?")) {
      const postData = {
        sale_id: sale_id,
        user_id: this.user_data.user_id
      }
      this.loaderService.display(true);
      this.reportService.SaleFinalize(postData).subscribe((result: any) => {
        window.scrollTo(0, 0)
        if (result["status"] == "Success") {
          this.loaderService.display(false);
          this.toastr.success(result.msg);
          this.sale.sale_id = result.data_id;
          this.getSaleList(this.page - 1);

        } else {
          this.toastr.error(result.msg);
          this.loaderService.display(false);
        }
      })
    }
  }

  public getSale(sale_id: any) {
    this.cleardata();
    const postData = {
      sale_id: sale_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.getSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.to_mail_address = this.saled.CUSTOMER_EMAIL
        this.item_list = result['data'].SALE;
        let i = 0;
        this.sale_details = ['0'];
        const sale_details = [];
        this.sale.patient_name = this.saled.PATIENT_NAME;
        this.sale.customer = this.saled.CUSTOMER_NAME
        this.sale.order_no = result["INVOICE_NUMBER"]["data"];
        this.sale.state = this.saled.STATE_NAME;
        this.sale.state_id = this.saled.STATE_ID;
        this.sale.chequeno = this.saled.CHEQUE_CARD_NUMBER;
        this.sale.cardno = this.saled.CARD_NUMBER;
        this.sale.sale_id = this.saled.SALE_ID;
        this.sale.vat_no = this.saled.VAT_NO;
        this.sale.remark = this.saled.ONLINE_REMARK;
        this.sale.license_no = this.saled.DRUG_LICENSE_NUMBER;
        this.sale.shipping_address = this.saled.SHIPPING_ADDRESS;
        this.sale.customer_address = this.saled.CUSTOMER_ADDRESS;
        this.sale.payment_type = this.saled.PAYMENT_TYPE;
        this.sale.freight_charge = this.saled.FREIGHT_CHARGE;
        this.sale.discount = this.saled.DISCOUNT;
        if (this.sale.vat_no) {
          environment.FLOOD_CESS_PERCENTAGE = 0;
        } else {
          environment.FLOOD_CESS_PERCENTAGE = 0;
        }
        for (const val of result['data'].SALE) {
          sale_details.push(i);
          this.sale.medicine_data[i] = {
            'MEDICINE_ID': val.MEDICINE_ID,
            'TRADE_NAME': val.TRADE_NAME,
            'DDC_CODE': val.DDC_CODE,
            'SCIENTIFIC_CODE': val.SCIENTIFIC_CODE,
            'SCIENTIFIC_NAME': val.SCIENTIFIC_NAME
          };
          this.sale.product_arr[i] = val.PRODUCT_CODE;
          this.sale.quantity_arr[i] = val.QUANTITY;
          this.sale.uom_arr[i] = val.UNIT_ID;
          this.sale.uom_arr_name[i] = val.UNIT_DESC;
          this.sale.MRP[i] = val.MRP;
          this.sale.purchase_details_id_arr[i] = val.PURCHASE_DETAILS_ID
          this.sale.mark_free_of_cost[i] = val.MARK_FOC
          this.sale.medicine_id_arr[i] = val.MEDICINE_ID

          this.sale.vat_arr[i] = val.VAT;
          this.sale.vatamt_arr[i] = val.VAT_AMOUNT;

          this.sale.mark_free_of_cost[i] = val.MARK_FOC == 1;
          if (val.WAREHOSE_AVAILABLE_QUANTITY == "" || val.WAREHOSE_AVAILABLE_QUANTITY == null) {
            this.sale.ava_quantity_arr[i] = val.AVAILABLE_STOCK_QUANTITY;
          } else {
            this.sale.ava_quantity_arr[i] = val.WAREHOSE_AVAILABLE_QUANTITY;
          }
          this.sale.warehouse_arr[i] = val.WAREHOUSE_ID;
          this.sale.warehouse_details_id_arr[i] = val.WARE_HOUSE_STOCK_DETAILED_ID;
          this.sale.total_arr[i] = val.TOTAL
          this.sale.unitprice_arr[i] = val.RETAIL_PRICE
          this.sale.flood_arr[i] = val.FLOOD_CESS;
          this.sale.base_price[i] = val.UNIT_PRICE;
          this.warehouselist(val.MEDICINE_ID, i);
          i = i + 1;
        }
        this.sale_details = sale_details;
        this.filelist = result['data'].ATTACHMENTS;
        this.total();
        this.totalAmount();
        this.getSum();
        this.totalprice();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public warehouselist(item_id: any, i: any) {
    const postData = {
      medicine_id: item_id
    };
    this.loaderService.display(true);
    this.loaderService.display(false);
    this.consultingService.warehouselist(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.sale.warehouses_data[i] = result['data'];
      } else {
        this.sale.warehouses_data[i] = []
      }
    });
  }


  public availableqty(i: any) {

    this.sale.quantity_arr[i] = '1'
    this.sale.price_arr[i] = ''
    this.sale.dis_arr[i] = ''
    this.sale.total_arr[i] = ''
    this.sale.MRP [i] = ''
    const postData = {
      medicine_id: this.sale.medicine_id_arr[i],
      warehouse_details_id: this.sale.warehouse_details_id_arr[i],
    };
    this.loaderService.display(true);
    this.reportService.detailedlist(postData).subscribe((result: any) => {

      this.loaderService.display(false);
      if (result["status"] == "Success") {
        const item_data = result["data"]
        this.sale.medicine_id_arr[i] = item_data.MEDICINE_ID;
        this.sale.warehouse_arr[i] = item_data.WAREHOUSE_ID;
        this.sale.product_arr[i] = item_data.PRODUCT_CODE;
        this.sale.uom_arr[i] = item_data.UNIT_ID;
        this.sale.uom_arr_name[i] = item_data.UNIT_DESC;
        this.sale.MRP[i] = item_data.MRP;
        this.sale.warehouse_details_id_arr[i] = item_data.WAREHOUSE_STOCK_DETAIL_ID;

        this.sale.vat_arr[i] = item_data.VAT;

        if (item_data.WAREHOSE_AVAILABLE_QUANTITY > 0) {
          this.sale.ava_quantity_arr[i] = item_data.WAREHOSE_AVAILABLE_QUANTITY;
        } else {
          this.sale.ava_quantity_arr[i] = 0;
        }
        this.sale.purchase_details_id_arr[i] = item_data.PURCHASE_DETAILS_ID;

        const vat = parseFloat(this.sale.vat_arr[i]);
        if (this.sale.slab) {
          if (this.sale.slab == 1) {
            this.sale.unitprice_arr[i] = item_data.SLAB_A_AMOUNT;
            this.sale.slab_per[i] = item_data.SLAB_A;
          }
          if (this.sale.slab == 2) {
            this.sale.unitprice_arr[i] = item_data.SLAB_B_AMOUNT;
            this.sale.slab_per[i] = item_data.SLAB_B;
          }
          if (this.sale.slab == 3) {
            this.sale.slab_per[i] = item_data.SLAB_C;
            this.sale.unitprice_arr[i] = item_data.SLAB_C_AMOUNT;
          }
        } else {
          this.sale.unitprice_arr[i] = item_data.MRP;
        }
        const unit = parseFloat(this.sale.unitprice_arr[i]);
        this.sale.base_price[i] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2);
        this.sale.flood_arr[i] = ((unit / (environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2);
        this.totalprice();
        this.totalAmount();
      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    })


  }


  public giveMarkFOC(index: any) {

    if (this.sale.mark_free_of_cost[index] == true) {
      this.sale.mark_free_of_cost[index] = true
      this.sale.vatamt_arr[index] = 0;
      this.sale.unitprice_arr[index] = 0;
      this.sale.base_price[index] = 0;
      this.sale.flood_arr[index] = 0;
      this.sale.total_arr[index] = 0;
      this.sale.price_arr[index] = 0;
      this.totalAmount();
      this.totalprice();
      this.total();
    }
    this.sale.mark_free_of_cost.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
    });
  }

  public cancel(sale_id: any) {
    this.sale.sale_id = sale_id
  }

  public cancelInvoice(reason: any): any {

    if (this.cancel_reason == '') {
      this.toastr.error("Please enter Invoice cancel reason!")
      this.opens(reason);
      return false;
    }
    const postData = {
      sale_id: this.sale.sale_id,
      user_id: this.user_data.user_id,
      cancel_reason: this.cancel_reason

    }
    this.loaderService.display(true);
    this.reportService.CancelInvoice(postData).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.toastr.success(result.msg);
        this.sale.sale_id = result.data_id; 
      } else {
        this.toastr.error(result.msg);
      }
      this.loaderService.display(false);
      this.getSaleList(this.page - 1);
    })
  }

  public clear_sale() {
    this.sale_details = ["0"];
    this.total_amount = 0;
    this.net_total = 0;
    this.sale = {
      sale_id: 0,
      patient_name: '',
      payment_type: 1,
      bill_type: 1,
      patient_no: '',
      doctor: '',
      customer: '',
      sale_date: new Date(),
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      customer_address: "",
      state_id: 0,
      order_no: '',
      vat_no: '',
      slab: 1,
      cardno: '',
      chequeno: '',
      remark: '',
      license_no: '',
      shipping_address: '',
      medicine_data: [],
      slab_per: [""],
      flood_arr: [""],
      base_price: [""],
      medicine_id_arr: [""],
      ava_quantity_arr: [""],
      quantity_arr: ["1"],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      price_arr: [""],
      MRP: [""],
      dis_arr: [""],
      user_id: '',
      total_arr: [""],
      unitprice_arr: [''],
      product_arr: [""],
      vat_arr: [""],
      vatamt_arr: [""],
      purchase_details_id_arr: [""],
      warehouse_arr: [""],
      warehouse_details_id_arr: [""],
      mark_free_of_cost: [false],
      upload_file: [],
      removeUpload: [],
      warehouses_data: [],
    }
    this.fileName = []
  }

  public cleardata() {
    this.sale.medicine_id_arr = [""]
    this.sale.slab_per = [""]
    this.sale.base_price = [""]
    this.sale.ava_quantity_arr = [""]
    this.sale.quantity_arr = ["1"]
    this.sale.uom_arr = [""]
    this.sale.uom_arr_name = [""]
    this.sale.amount_arr = [""]
    this.sale.medicine_data = []
    this.sale.flood_arr = [""]
    this.sale.price_arr = [""]
    this.sale.MRP = [""]
    this.sale.dis_arr = [""]
    this.sale.user_id = ''
    this.sale.total_arr = [""]
    this.sale.unitprice_arr = [""]
    this.sale.product_arr = [""]
    this.sale.vat_arr = [""]
    this.sale.vatamt_arr = [""]
    this.sale.purchase_details_id_arr = [""]
    this.sale.mark_free_of_cost = [false]
    this.sale.upload_file = []
    this.sale.removeUpload = []
    this.sale.warehouses_data = []
    this.fileName = []
  }

  public checkcheck() {
    this.checked = !this.checked;
    this.getSaleList();
  }

  public getSaleList(page = 0) {
    const limit = 50;
    this.start = page * limit;
    this.limit = limit;
    const postData = {
      checked: this.checked,
      start: this.start,
      limit: this.limit,
      sale_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.listSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.sale_data = result['data'];
        this.collection = result['total_count'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
      }
    });
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.sale.search_sale,
      sale_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.listSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.sale_data = result['data'];
        this.collection = result['total_count'];
        const i = this.sale_data.length;
        this.index = i + 5;
        this.status = result['status'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.status = result['status'];
      }
    });
  }

  public clear_search() {
    if (this.sale.search_sale != '') {
      this.sale.search_sale = '';
      this.getSaleList();
    }
  }

  public attachmentPath(filename: any) {
    return environment.SALE_UPLOAD_PATH + filename;
  }

  public sale_items(item: any) {
    const postData = {
      sale_id: item
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.getSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.to_mail_address = this.saled.CUSTOMER_EMAIL
        this.sale_credit.payment_credit = this.saled.PAYMENT_CREDIT
        this.sale_credit.credit_date = this.saled.PAYMENT_CREDIT_DATE
        if (this.saled.RECEIVED_AMOUNT == null) {
          this.sale_credit.payment_received = 0
        } else {
          this.sale_credit.payment_received = this.saled.RECEIVED_AMOUNT
        }
        this.item_list = result['data'].SALE;
        this.file_list = result['data'].ATTACHMENTS;
        let i = 0;
        if (this.sale.vat_no) {
          environment.FLOOD_CESS_PERCENTAGE = 0;
        } else {
          environment.FLOOD_CESS_PERCENTAGE = 0;
        }
        for (const data of this.item_list) {
          const unit = parseFloat(data.UNIT_PRICE);
          const vat = parseFloat(data.VAT);
          if (this.saled && this.saled.TIN_NUMBER == 32) {
            data["BASE_PRICE"] = ((unit / (environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          if (this.saled && this.saled.TIN_NUMBER != 32) {
            data["BASE_PRICE"] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2)
          }
          this.item_list[i] = data;
          i = i + 1;
        }
        this.getVatValue();
        this.count = this.item_list.length;
        if (this.count > 10) {
          this.split = this.count / 10;
          const mode = this.count % 10;
          if (mode > 0) {
            this.split = this.split + 1;
          }

        }
        for (let i = 0; i <= this.split; i++) {
          const start = 10 * i; // 0 // 10 // 20
          let end = 10 * (i + 1); // 10 // 20 // 30
          if (end > this.count) {
            end = this.count; // 25
          }
          this.print_list_array[i] = [];
          for (let j = start; j < end; j++) {
            this.print_list_array[i].push(this.item_list[j]);
          }
        }
        this.getSum();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public getVatValue() {
    const postData = {

      sale_id: this.saled.SALE_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.getVatValue(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.vat_list = result['data'];
        let total_vat = 0
        let total_flood = 0
        for (const vat of this.vat_list) {
          total_vat = total_vat + parseFloat(vat.VAT_VALUE)
          total_flood = total_flood + parseFloat(vat.FLOOD_CESS)
        }

        this.total_vat = (total_vat)
        this.total_flood = (total_flood)
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public round(data: any) {
    return Math.round(data)
  }

  getSum() {
    let total = 0;
    let save = 0;
    for (const item of this.item_list) {
      total = total + parseFloat(item.TOTAL);
      save = save + parseFloat(item.SAVE_RATE);
    }
    this.save_rate = Math.round(save);
    this.gross = total
    if (this.saled) {
      this.price_total = Math.round((this.gross - parseFloat(this.saled.DISCOUNT)) + parseFloat(this.saled.FREIGHT_CHARGE))
    } else {
      this.price_total = Math.round(this.gross)
    }
    this.numberToWords = (numberToWords.toWords(this.price_total));
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public set_item_medicine($event: any, i: any) {
    this.sale.quantity_arr[i] = '1'
    this.sale.price_arr[i] = ''
    this.sale.dis_arr[i] = ''
    this.sale.total_arr[i] = ''
    this.sale.MRP [i] = ''
    this.sale.slab_per[i] = ''
    this.sale.base_price[i] = ''
    this.sale.ava_quantity_arr[i] = ''
    this.sale.uom_arr[i] = ''
    this.sale.uom_arr_name[i] = ''
    this.sale.amount_arr[i] = ''
    this.sale.medicine_data[i] = ''
    this.sale.flood_arr[i] = ''
    this.sale.user_id = ''
    this.sale.unitprice_arr[i] = ''
    this.sale.product_arr[i] = ''
    this.sale.vat_arr[i] = ''
    this.sale.vatamt_arr[i] = ''
    this.sale.warehouse_arr[i] = ''
    this.sale.warehouse_details_id_arr[i] = ''
    this.sale.purchase_details_id_arr[i] = ''
    this.sale.warehouses_data[i] = [""]
    const item = $event.item;
    this.sale.medicine_id_arr[i] = item.MEDICINE_ID
    this.warehouselist(item.MEDICINE_ID, i);
  }

  public totalprice() {
    let sum = 0;
    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.mark_free_of_cost[index] = true
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
      if (parseInt(this.sale.ava_quantity_arr[index]) < parseInt(this.sale.quantity_arr[index])) {
        this.toastr.error('Invalid quantity');
        return false;
      }
      let mrp = 0;
      if (this.sale.state != '') {
        const vat = parseFloat(this.sale.MRP[index]) * (parseFloat(this.sale.vat_arr[index]) / 100);
        mrp = parseFloat(this.sale.MRP[index]) + vat

      }
      if (mrp < parseFloat(this.sale.unitprice_arr[index])) {
        this.toastr.error('Retail price should be less than or equal to MRP price');
        return false;
      } else {
        if (parseInt(this.sale.quantity_arr[index]) > 0 && parseFloat(this.sale.unitprice_arr[index]) > 0 && parseFloat(this.sale.unitprice_arr[index]) > 0 && this.sale.medicine_id_arr[index] > 0) {
          const qty = parseInt(this.sale.quantity_arr[index]);
          const base_price = parseFloat(this.sale.base_price[index]);
          if (!isNaN(qty)) {

            sum = qty * base_price;
          } else {
            sum = 0;
          }
          this.sale.price_arr[index] = sum.toFixed(2);
        }
      }

    });
  }

  public totalAmount() {
    let sum = 0
    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.mark_free_of_cost[index] = true
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
      if (parseInt(this.sale.quantity_arr[index]) > 0 && this.sale.medicine_id_arr[index] > 0) {
        const unit = parseFloat(this.sale.unitprice_arr[index])
        const vat = parseFloat(this.sale.vat_arr[index]);
        const qty = parseInt(this.sale.quantity_arr[index])

        this.sale.base_price[index] = ((unit / (vat + environment.FLOOD_CESS_PERCENTAGE + 100)) * 100).toFixed(2);
        const base_price = parseFloat(this.sale.base_price[index])
        const flood = (base_price * (environment.FLOOD_CESS_PERCENTAGE / 100)).toFixed(2)
        this.sale.flood_arr[index] = parseFloat(flood) * qty;
        const price = parseFloat(this.sale.price_arr[index]);
        const slab_price = parseFloat(this.sale.unitprice_arr[index]);

        if (!isNaN(price)) {
          sum = price;
        }

        if (!isNaN(vat && base_price)) {
          this.sale.vatamt_arr[index] = ((base_price * (vat / 100)) * qty).toFixed(2);
        }

        if (!isNaN(slab_price && qty)) {
          sum = slab_price * qty
        }
        this.sale.total_arr[index] = sum.toFixed(2);
        this.total();
      }

    });
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public total() {
    let sum = 0;
    this.sale.quantity_arr.forEach((_item: any, index: any): any => {
      if (this.sale.mark_free_of_cost[index] == true) {
        this.sale.mark_free_of_cost[index] = true
        this.sale.vatamt_arr[index] = 0;
        this.sale.unitprice_arr[index] = 0;
        this.sale.base_price[index] = 0;
        this.sale.flood_arr[index] = 0;
        this.sale.total_arr[index] = 0;
        this.sale.price_arr[index] = 0;
      }
      const total = parseFloat(this.sale.total_arr[index]);
      if (!isNaN(total)) {
        sum = sum + total
      }

    });
    this.total_amount = sum;
    if (this.sale.discount != 0 && this.total_amount && this.sale.freight_charge != 0) {

      const freight_charge = parseFloat(this.sale.freight_charge)
      const discount = parseFloat(this.sale.discount);
      this.net_total = Math.round((this.total_amount + freight_charge) - discount);
    } else if (this.sale.freight_charge != 0 && this.total_amount && this.sale.disc_per == 0) {
      const freight_charge = parseFloat(this.sale.freight_charge)
      this.net_total = Math.round((this.total_amount + freight_charge));
    } else {
      this.net_total = Math.round(this.total_amount);
    }
  }

  public selectCoinPaymentType(val: any) {
    this.sale.payment_type = val;
  }

  public addrow(index: any) {
    this.sale_details[index + 1] = '';
    this.sale.medicine_data[index + 1] = '';
    this.sale.uom_arr_name[index + 1] = '';
    this.sale.price_arr[index + 1] = '';
    this.sale.total_arr[index + 1] = '';
    this.sale.unitprice_arr[index + 1] = '';
    this.sale.quantity_arr[index + 1] = '1';
    this.sale.ava_quantity_arr[index + 1] = '';
    this.sale.price_arr[index + 1] = '';
    this.sale.purchase_details_id_arr[index + 1] = '';
    this.sale.mark_free_of_cost[index + 1] = false;
    this.sale.product_arr[index + 1] = '';
    this.sale.vat_arr[index + 1] = '';
    this.sale.vatamt_arr[index + 1] = '';
    this.sale.warehouse_arr[index + 1] = '';
    this.sale.warehouse_details_id_arr[index + 1] = '';
  }

  public deleterow(index: any) {
    this.sale_details.splice(index, 1);
    this.sale.medicine_data.splice(index, 1);
    this.sale.medicine_id_arr.splice(index, 1);
    this.sale.quantity_arr.splice(index, 1);
    this.sale.uom_arr_name.splice(index, 1);
    this.sale.amount_arr.splice(index, 1);
    this.sale.price_arr.splice(index, 1);
    this.sale.dis_arr.splice(index, 1);
    this.sale.total_arr.splice(index, 1);
    this.sale.unitprice_arr.splice(index, 1);
    this.sale.MRP.splice(index, 1);
    this.sale.ava_quantity_arr.splice(index, 1);
    this.sale.price_arr.splice(index, 1);
    this.sale.purchase_details_id_arr.splice(index, 1);
    this.sale.mark_free_of_cost.splice(index, 1);
    this.sale.product_arr.splice(index, 1);
    this.sale.vat_arr.splice(index, 1);
    this.sale.vatamt_arr.splice(index, 1);
    this.sale.warehouse_arr.splice(index, 1);
    this.sale.warehouse_details_id_arr.splice(index, 1);
    this.total();
  }

  medicine_search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.salesService.medicine_search(term).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([])
          })
        )
      ),
      tap(() => this.searching = false)
    )

  formatter = (x: any): any => x.TRADE_NAME;

  protected open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'a4-page',
      windowClass: "custom"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected opens(content: any) {
    this.modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.modalRef.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected open_copy(content: any) {
    this.modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    this.modalRef.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
